import request from '@/middleware/request'

const getKeyValueExplorerList = () => {
  return request({
    url: '/key_value_explorers',
    method: 'get'
  })
}

const getKeyValueExplorer = data => {
  return request({
    url: '/key_value_explorers/search',
    method: 'post',
    data
  })
}

const createKeyValueExplorer = data => {
  return request({
    url: '/key_value_explorers',
    method: 'post',
    data
  })
}

const updateKeyValueExplorer = (id, data) => {
  return request({
    url: `/key_value_explorers/${id}`,
    method: 'patch',
    data
  })
}

const deleteKeyValueExplorer = id => {
  return request({
    url: `/key_value_explorers/${id}`,
    method: 'delete'
  })
}

export default {
  getKeyValueExplorerList,
  getKeyValueExplorer,
  createKeyValueExplorer,
  updateKeyValueExplorer,
  deleteKeyValueExplorer
}
